import React, { createContext } from "react";
import i18next from "i18next";
import contentFR from "static/content/fr";
import contentDE from "static/content/de";
import contentES from "static/content/es";
import contentPT from "static/content/pt";
import contentIT from "static/content/it";

const contentObj = contentFR;
const contentObjFr = contentFR;

/**
 * initial state
 */
export const ContentContext = createContext({
  content: "",
  base: {},
  lang: "",
  isi18next: false,
  resetContext: () => {},
  updateContent: () => {},
  changeLang: () => {},
  c: () => {},
});

const url = new URL(window.location.href);
const ext = url.hostname.lastIndexOf(".");
const lang =
  url.hostname.substring(ext + 1) === "localhost" ? "es" : url.hostname.substring(ext + 1);

export class ContentProvider extends React.Component {
  state = {
    content: contentObj,
    base: contentObj,
    lang,
    isi18next: false,
    updateContent: value => this.updateContent(value),
    changeLang: value => this.updateContent(value),
    resetContext: () => this.resetContext(),
    c: key => this.c(key),
  };

  componentDidMount() {
    i18next.init(
      {
        lng: lang,
        debug: true,
        resources: {
          fr: {
            translation: contentObjFr,
          },
          de: {
            translation: contentDE,
          },
          es: {
            translation: contentES,
          },
          pt: {
            translation: contentPT,
          },
          it: {
            translation: contentIT,
          },
        },
      },
      (err, t) => {
        this.setState({
          isi18next: true,
        });
      },
    );

    // i18next.t('key');
  }

  resetContext = () => {
    this.setState({ content: contentObj });
  };

  getContent = async page => {
    this.setState({ content: contentObj[page] });
  };

  c = key => i18next.t(key.toString());

  changeLang = async lang => {
    this.setState({ lang });
  };

  render() {
    const { isi18next } = this.state;
    if (!isi18next) {
      return null;
    }

    return (
      <ContentContext.Provider value={this.state}>{this.props.children}</ContentContext.Provider>
    );
  }
}

/**
 * consumer
 */

export const ContentConsumer = ContentContext.Consumer;
